import { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, TextField, Typography, Link, Alert } from '@mui/material';
import api from '../api/axios';
import AuthCard from '../components/AuthCard';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { data } = await api.post('/auth/forgot-password', { email });
      setSent(data.message || 'If that address has an account, a reset link is on its way.');
    } catch (err) {
      setError(err.response?.data?.error || 'Could not send the reset link. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthCard>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h6" sx={{ mb: 0.25 }}>
          Forgot your password?
        </Typography>
        <Typography variant="body2" color="text.secondary">
          We&apos;ll email you a link to choose a new one.
        </Typography>
      </Box>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      {sent ? (
        <Alert severity="success">
          {sent}
        </Alert>
      ) : (
        <form onSubmit={handleSubmit}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField
              label="Email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              fullWidth
              autoFocus
              autoComplete="email"
            />
            <Button
              type="submit"
              variant="contained"
                              fullWidth
              disabled={loading}
              sx={{ mt: 0.5 }}
            >
              {loading ? 'Sending…' : 'Send reset link'}
            </Button>
          </Box>
        </form>
      )}

      <Typography variant="body2" sx={{ mt: 2.5, textAlign: 'center', color: 'text.secondary' }}>
        <Link component={RouterLink} to="/login" underline="hover" color="primary">
          Back to sign in
        </Link>
      </Typography>
      </AuthCard>
  );
}
